import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Portal } from 'react-overlays';
import { connect } from 'react-redux';

import { hideCredits } from '~app/actions/credits';

import CreditsScreen from './CreditsScreen';

class CreditsModal extends Component {

  render() {
    return (
      (this.props.show) &&
      <Portal>
        <CreditsScreen
          onClose={this.props.hideCredits}
        />
      </Portal>
    );
  }
}

CreditsModal.propTypes = {
  show: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  show: state.credits.show,
});

const mapDispatchToProps = {
  hideCredits,
};

export { CreditsModal };
export default connect(mapStateToProps, mapDispatchToProps)(CreditsModal);



// WEBPACK FOOTER //
// ./src/components/CreditsModal.js